
import { defineComponent, ref, watch } from "vue";
import DynamicFormInJson from "@/components/DynamicFormInJson.vue";
import ElSelectExt from "@/components/ElSelectExt.vue";

const componentMap: any = {
  ElSelectExt,
  DynamicFormInJson
}

export default defineComponent({
  components: { DynamicFormInJson },
  emits: ["update:model"],
  name: "DynamicJsonForm",
  props: {
    model: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    view: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: "120px",
    },
    columns: {
      type: Array,
      required: true,
    },
    roleIds: {
     type: Array,
    },
    colSpan: {
      type: Number,
      default: 8,
    },
    modalCol: {
      type: Number,
      default: 2,
    }
  },
  setup(props, { emit }) {
    console.log('xxxxxxxxxxxx')
    const jsonList = ref(JSON.parse(props.model?props.model:'[]'))
    const filterColumns:any = ref([])
    const rows:any = ref([])


    const getComponent = (item: any) => {
      const componentName = item.component
      const component = componentMap[componentName]
      if (!component) {
        return componentName
      }
      return component
    }

    watch( props.columns, (newColumns) => {
      filterColumns.value = []
      rows.value = []
      newColumns.forEach((item: any) => {
        const tempOptions = JSON.parse(item.componentOptions);
        if (tempOptions[props.field]) {
          filterColumns.value.push(item);
        }
      })
      for (let i = 0; i < filterColumns.value.length; i++) {
        const cols = [];
        for (let j = 0; j < props.modalCol; j++) {
          cols.push(filterColumns.value[i + j]);
        }
        rows.value.push(cols);
        i += props.modalCol - 1;
      }
    }, { deep: true, immediate: true})


    const handleChildFormUpdate = (newForm: Record<string, any>, jix: number) => {
      jsonList.value[jix] = newForm
      emit('update:model', JSON.stringify(jsonList.value), props.field)
    }
    const addData = () => {
      const child: any = {show: true};
      filterColumns.value.forEach((item: any) => {
        child[item.columnName] = "";
      })
      jsonList.value.push(child);
    };

    const handleDeleteChildClick = (cix: number, child: any) => {
      jsonList.value.splice(cix, 1);
    };
    return {
      handleChildFormUpdate,
      jsonList,
      rows,
      addData,
      filterColumns,
      handleDeleteChildClick,
      getComponent
    };
  },
});

